import { useMemo, useRef, useEffect } from 'react'

import { useHospitalDetailContext } from '../hospital-detail-context'

import { useLocales } from '@/shared/hooks/useLocales'
import { HospitalReviewSection } from '@/features/hospital/components/hospital-review-section'

export const HospitalDetailReviews = () => {
  const { locale } = useLocales()
  const { user, hospital, reviews, registerSectionRef } = useHospitalDetailContext()
  const sectionRef = useRef<HTMLDivElement>(null)

  const isAnonymousUser = !user || user.id === 0
  const hasReview = hospital.statistic?.reviewCount > 0

  // Amplitude properties를 useMemo로 최적화
  const commonAmplitudeProperties = useMemo(
    () => ({
      hospital_id: hospital.hospitalId,
      hospital_name: hospital.name,
      hospital_region: hospital.location.sido,
    }),
    [hospital.hospitalId, hospital.name, hospital.location.sido],
  )

  // Register section ref for scroll navigation
  useEffect(() => {
    registerSectionRef('review', sectionRef.current)
    return () => registerSectionRef('review', null)
  }, [registerSectionRef])

  // 리뷰가 없으면 렌더링하지 않음
  if (!hasReview) {
    return null
  }

  return (
    <div ref={sectionRef}>
      <HospitalReviewSection
        reviewWithPagination={reviews}
        hospital={hospital}
        isAnonymousUser={isAnonymousUser}
        locale={locale}
        commonAmplitudeProperties={commonAmplitudeProperties}
      />
    </div>
  )
}
